module.exports = __webpack_public_path__ + "static/img/bhimkanta.14dd5919.jpg";